import React from 'react'

const Hero = () => {
  return (
    <>
      <div className="Hero" id="home">
        <img
          className="fream"
          src="https://res.cloudinary.com/defcamc5x/image/upload/v1761239096/xytnkzb46nwkxtduvusw.png"
          alt=""
        />
        <img
          className="alaa"
          src="https://res.cloudinary.com/defcamc5x/image/upload/v1761239568/qziu7rc6mnrrhcb69c6q.webp"
          alt=""
        />
        <div className="container">
          <div className="mainContent">
            <div className="content">
              <h1>مكتب علاء الدين حامد</h1>
              <p>حيث يكون القانون رسالة، ويكون الإنصاف طريقًا لا نحيد عنه</p>
              <div className="buttons">
                <button>من نحن</button>
                <button>اتصل بنا</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="subHero">
        <div className="container">
          <div className="content">
            <h1>مكتب علاء الدين حامد</h1>
            <p>حيث يكون القانون رسالة، ويكون الإنصاف طريقًا لا نحيد عنه</p>
            <div className="buttons">
              <button>من نحن</button>
              <button>اتصل بنا</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero